import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ANALYTICS_CONFIG, AnalyticsConfig } from './models/event-types';
import { TixAnalyticsService } from './services/tix-analytics.service';

@NgModule({
  imports: [CommonModule],
  providers: [TixAnalyticsService]
})
export class SharedAnalyticsModule {
  static forRoot(
    config: AnalyticsConfig
  ): ModuleWithProviders<SharedAnalyticsModule> {
    return {
      ngModule: SharedAnalyticsModule,
      providers: [
        {
          provide: ANALYTICS_CONFIG,
          useValue: config
        }
      ]
    };
  }
}
